export default __webpack_public_path__ + "static/media/ico-gas.d53a37ca.svg";